export const AI_TEST_MESSAGE_DEBOUNCE_MS = 8000

export function buildAITestMessageBatch(messages = []) {
    const normalized = messages
        .map(message => ({
            text: String(message?.text || "").trim(),
            client_id: message?.client_id,
            created_at: message?.created_at
        }))
        .filter(message => message.text)

    return {
        text: normalized.map(message => message.text).join("\n"),
        messages: normalized
    }
}
